enum TooltipPositionEnum {
  Top = 'Top',
  Bottom = 'Bottom',
  BottomLeft = 'BottomLeft',
  Custom = 'Custom',
}
export default TooltipPositionEnum;
